import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import RemarkMenu from '../../../components/MasterData/RemarkMenu';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconInformationBlue from '../../../assets/icons/IconInformationBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_REMARK from '../../../api/apiRemark';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_REMARK_UPDATE,
    MASTER_DATA_REMARK_VIEW
} from '../../../constants/menuPermissionConstant';

class DocumentHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Deskripsi Remark",
                    dataIndex: "description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, documentHeaderDataSelectedEdit: data, documentHeader: data.description })}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            listDocumentHeader: [],
            documentHeader: '',
            documentHeaderDataSelectedEdit: {},
            documentHeaderDataSelectedDelete: {},
            showWarningDocumentHeader: false,
            showPopupInfo: false,
            showEditModal: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                // this.getInitiateDocumentHeader();
                this.getListDocumentHeader(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                // this.getInitiateDocumentHeader();
                this.getListDocumentHeader(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getInitiateDocumentHeader = () => {
        API_REMARK.getInitiateDocumentHeader(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListDocumentHeader = (current, pageSize) => {
        API_REMARK.getListDocumentHeader(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listDocumentHeader: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showEditModal: false,
            showWarningDocumentHeader: false,
            documentHeader: ''
        });
    }

    handleConfirmEditDocumentHeader = () => {
        if (!this.state.documentHeader) return this.setState({ showWarningDocumentHeader: true });
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditDocumentHeader = () => {
        const documentHeaderId = this.state.documentHeaderDataSelectedEdit.id;
        const data = {
            remark: this.state.documentHeaderDataSelectedEdit.remark,
            description: this.state.documentHeader,
            category: 'Document Header',
            category_id: this.state.documentHeaderDataSelectedEdit.category_id,
            updated_at: this.state.documentHeaderDataSelectedEdit.updated_at
        }

        API_REMARK.putDataRemark(documentHeaderId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        documentHeader: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditDocumentHeader = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            // this.getInitiateDocumentHeader();
            this.getListDocumentHeader(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;

        // this.getInitiateDocumentHeader();
        this.getListDocumentHeader(this.state.pagination.current, this.state.pagination.pageSize);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Remark"
                        title="Dokumen Header"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <RemarkMenu />

                            <div className="space-y-4">
                                <div className="flex justify-between items-center flex-row-reverse h-12">
                                    {/*  Document Header Information */}
                                    <div className="flex justify-center items-center relative">
                                        <div id="btninfo" className="cursor-pointer" onMouseEnter={() => this.setState({ showPopupInfo: true })} onMouseLeave={() => this.setState({ showPopupInfo: false })}>
                                            <IconInformationBlue />
                                        </div>
                                        <div className={this.state.showPopupInfo ? "absolute w-96 top-0 right-10 z-10 rounded-lg shadow-box-button p-5 text-sm bg-nexcarewhite2" : "hidden"}>
                                            <div className="italic">
                                                <p className="font-bold">Note :</p>
                                                <p>Dokumen Header digunakan untuk penentuan format penamaan awal untuk nomor tiket.</p>
                                                <p>Contoh jika value: CS</p>
                                                <p>CS230200058</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Table Document Header */}
                                <div>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listDocumentHeader}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Edit Document Header Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah Dokumen Header</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tsldocumentheaderedit"
                                        className="form-control"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="documentHeader"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningDocumentHeader: false });
                                        }}
                                        minLength="2"
                                        maxLength="5"
                                        autoComplete="off"
                                        value={this.state.documentHeader}
                                    />
                                    {this.state.showWarningDocumentHeader && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditdocumentheader" onClick={this.handleConfirmEditDocumentHeader}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan Dokumen Header" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditDocumentHeader} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditDocumentHeader} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentHeader);